module.exports = __webpack_public_path__ + "img/ic_burger_shop-active.c4479d06.svg";